import React from 'react'
import { TitleBar } from 'components/TitleBar'
import { useTranslation } from 'react-i18next'

function TraderTitleBar() {
  const { t } = useTranslation()

  return (<TitleBar title={t('pages.page', { context: 'traders' })} isMobileThin />)
}

export default TraderTitleBar
